import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TExcelManagementInfo } from '../../../../types';
import { ExcelManagementFacade } from '../../../../redux-store/excel-management/excel-management.facade';

@Component({
  selector: 'monorepo-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss'],
})
export class UploadModalComponent {
  @Input() excelInfo?: TExcelManagementInfo = undefined;

  constructor(private modalController: ModalController, private excelManagementFacade: ExcelManagementFacade) {}

  uploadFile(file: File) {
    if (this.excelInfo) this.excelManagementFacade.uploadExcel(file, this.excelInfo);
  }

  downloadFile() {
    if (this.excelInfo) this.excelManagementFacade.downloadSampleTemplate(this.excelInfo);
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
